/**
 * Created by Marvin on 17.04.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import ErrorHandlerContainer from '@wikom/frontend-logger';
import { useRoute } from '@app/router';
import Header from './Header';
import Footer from './Footer';
var Layout = function (_a) {
    var children = _a.children;
    var ROUTE = useRoute();
    return (React.createElement("div", { className: "wrap-outer" },
        React.createElement("div", { className: "wrap" },
            React.createElement(Header, null),
            React.createElement("div", { className: "container" },
                React.createElement(ErrorHandlerContainer, { apiUrl: ROUTE.API.LOG.REPORT({ category: 'page' }) }, children))),
        React.createElement(Footer, null)));
};
Layout.propTypes = {
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    children: PropTypes.node,
};
export default Layout;
